import { Loader } from '@southfields-digital/mpxlive-components';

import styles from './DataConnectorPanel.module.scss';

export const LoadingSection = () => {
  return (
    <div className={styles.LoadingSection}>
      <Loader />
    </div>
  );
};
